import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

const headerCell = { fontWeight: "bold" };

// The accounts that exist / were just created.
export const GoogleUsersTable = ({ rows }) => (
  <TableContainer
    component={Paper}
    sx={{ boxShadow: 3, maxHeight: 320, overflowY: "auto" }}
  >
    <Table
      size="small"
      stickyHeader
    >
      <TableHead>
        <TableRow>
          <TableCell sx={headerCell}>Входящ номер</TableCell>
          <TableCell sx={headerCell}>Google имейл</TableCell>
          <TableCell sx={headerCell}>Парола</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map(row => (
          <TableRow key={row.candidacyId}>
            <TableCell>{row.candidacyNumber}</TableCell>
            <TableCell>{row.googleEmail}</TableCell>
            <TableCell sx={{ fontFamily: "monospace" }}>{row.password}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

// The candidacies Google did not create an account for. Re-running the generation retries exactly these.
export const FailedGoogleUsersTable = ({ rows }) => (
  <>
    <Typography
      color="error"
      fontWeight="bold"
      sx={{ marginTop: "1.5rem", marginBottom: "0.5rem" }}
    >
      Неуспешно създадени акаунти ({rows.length}). Пропускат се до края на текущото генериране — затворете и
      стартирайте отново, за да бъдат опитани пак.
    </Typography>
    <TableContainer
      component={Paper}
      sx={{ boxShadow: 3, maxHeight: 240, overflowY: "auto" }}
    >
      <Table
        size="small"
        stickyHeader
      >
        <TableHead>
          <TableRow sx={{ bgcolor: theme => theme.palette.secondary.main }}>
            <TableCell sx={{ ...headerCell, color: "#fff" }}>Входящ номер</TableCell>
            <TableCell sx={{ ...headerCell, color: "#fff" }}>Заявен имейл</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map(row => (
            <TableRow key={row.candidacyId}>
              <TableCell sx={{ color: theme => theme.palette.error.main, fontWeight: "bold" }}>
                {row.candidacyNumber}
              </TableCell>
              <TableCell>{row.requestedEmail}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </>
);
